import { UserType } from '../../entities/tenant/user.type';
import { withFieldAppReleaseRights } from '../modules/field.app.section.rights';
import { MobileTechniciansSecurityRight } from '../modules/mobile.technicians.security.module';
import { withPortalContractorReleaseRights } from '../modules/portal.contractor.section.rights';
import { PortalContractorSecurityRight } from '../modules/portal.contractors.security.module';
import { AppSecurityRight } from '../modules/app.security';
import { SecurityRole, SecurityRoleType } from '../security.role';


export class SubcontractorAdministrator implements SecurityRole {

    _id = 'bd4e1fe0-5409-4aa4-8640-d05272f32f73';
    system = true;
    hidden = false;
    type = UserType.Subcontractor;
    name = SecurityRoleType.SubcontractorAdministrator;
    description = 'Access to operation dashboard and users, Can use the mobile app to update progress of jobs. These users work for 3rd party subcontractors.';
    rights = withFieldAppReleaseRights(withPortalContractorReleaseRights([
        AppSecurityRight.LoginContractor,
        AppSecurityRight.LoginField,
        MobileTechniciansSecurityRight.CanAccessJobs,
        MobileTechniciansSecurityRight.ManageJobManageAssets,
        PortalContractorSecurityRight.CanAccessJobs,
        PortalContractorSecurityRight.ManageUsers,
        PortalContractorSecurityRight.AddInviteUsers,
        PortalContractorSecurityRight.ManageCompliance,
        MobileTechniciansSecurityRight.CanAccessTimesheets,
        MobileTechniciansSecurityRight.AllowEditBeforeCheckIn,
        PortalContractorSecurityRight.ModifyFormAfterSubmission,
    ]));

}

